import { Flex } from '@cad-arc';
import { DexFormFieldView } from '@mark43/cad-api';
import { DexField } from './dex-field';
import { useDexFormName } from './dex-form-name';

export function DexFormRow({
    fields,
    autoFocusField,
}: {
    fields: DexFormFieldView[];
    autoFocusField?: string;
}): React.ReactElement {
    const dexFormName = useDexFormName();

    return fields.length === 1 ? (
        <DexField
            dexFieldView={fields[0]}
            autoFocus={autoFocusField !== undefined ? autoFocusField === fields[0].name : undefined}
        />
    ) : (
        <Flex
            width="100%"
            alignItems="center"
            justifyContent="flex-start"
            flexWrap="wrap"
            gap="10px"
        >
            {fields.map((field) => {
                return (
                    <DexField
                        dexFieldView={field}
                        key={dexFormName ? `${dexFormName}-${field.name}` : field.name}
                        autoFocus={
                            autoFocusField !== undefined ? autoFocusField === field.name : undefined
                        }
                    />
                );
            })}
        </Flex>
    );
}
